import React from 'react';
import PropTypes from 'prop-types';
import CustomSkeleton from 'components/CustomSkeleton';
import DashboardTransactionSummaryCard from './DashboardTransactionSummaryCard';
import DashboardCommissionSummaryCard from './DashboardCommissionSummaryCard';

function DashBoardSummaryCard({ dashBoardSummary, summaryKey }) {
  switch (summaryKey) {
    case 'TRANSACTION':
      return <DashboardTransactionSummaryCard dashBoardSummary={dashBoardSummary} />;
    case 'COMMISSION':
      return <DashboardCommissionSummaryCard dashBoardSummary={dashBoardSummary} />;
    default:
      return <CustomSkeleton />;
  }
}
DashBoardSummaryCard.propTypes = {
  dashBoardSummary: PropTypes.instanceOf(Object).isRequired,
  summaryKey: PropTypes.string.isRequired
};

export default DashBoardSummaryCard;
